// src/utils/adminDataErrorTable.ts

import { SupportTicketSummaryApi } from "@/types/supportTicket";

// ---- small helpers (reused) ----
export const parseNumberOrText = (value: any) => {
  if (value === null || value === undefined) return "";
  const v = String(value).trim();
  if (v === "-" || v === "") return "";
  const num = Number(v);
  return Number.isFinite(num) ? num : v; // allow text if needed
};

export const toFieldName = (key: string) => {
  if (!key) return key;
  const parts = key.split(" ");
  parts[0] = parts[0].charAt(0).toLowerCase() + parts[0].slice(1);
  return parts.join("").replace(/[^\w]/g, "");
};

// ---- column builder (ONLY fields from the provided response) ----
export const buildAdminErrorColumns = () => {
  // Only columns that exist in your API response + a computed "Ticket Status"
  const existingCols: any[] = [

    "Menu",
    "Category",
    "Function Name",
    "Description",
    "Plant Id",
    "Material Number",
    "IO Extraction Date",
    "Urgency",
    "SSA Identifier",
    // "MS Case ID",
    "MS Case Number",
    "Created By",
    "Ticket Status", // computed from flags
    {
      groupHeaderName: "Audit",
      marryChildren: true,
      children: ["Created Timestamp", "Last Modified Date"],
    },
  ];

  const ensureCol = (header: string): any => {
    const field = toFieldName(header);
    return { field, headerName: header };
  };

  const columnDefs: any[] = [];
  existingCols.forEach((entry) => {
    if (typeof entry === "string") {
      columnDefs.push(ensureCol(entry));
    } else {
      const { groupHeaderName, children, marryChildren = true } = entry;
      const childDefs = children.map((h: string) => ensureCol(h));
      columnDefs.push({
        headerName: groupHeaderName,
        marryChildren,
        children: childDefs,
      });
    }
  });

  return columnDefs;
};

// ---- row/calculation builder (ONLY maps fields that exist in the response) ----
export const buildAdminErrorRows = (
  source: SupportTicketSummaryApi[],
  columns: any[]
) => {
  // Helper: compute ticket status from flags
  const getTicketStatus = (row: any) => {
    if (row.isResolved) return "Resolved";
    if (row.isTicketInprogress) return "In Progress";
    if (row.isTicketCreated) return "Created";
    return "Not Created";
  };
console.log("source",source)
   const data = source.map((row,idx ) => {
    const obj: any = {};
obj.__uid = row.id ?? `${row.materialNumber ?? "mat"}__${idx}`;
    // Walk columns and map values
    columns.forEach((col: any) => {
      const assign = (headerName: string, value: any) => {
        const field = toFieldName(headerName);
        obj[field] = value ?? "";
      };

      const mapOne = (headerName: string) => {
        switch (headerName) {
         
          case "Menu":
            assign(headerName, row.menu);
            break;
          case "Category":
            assign(headerName, row.category);
            break;
          case "Function Name":
            assign(headerName, row.functionName);
            break;
          case "Created By":
            assign(headerName, row.createdBy);
            break;
          case "Description":
            assign(headerName, row.description);
            break;
          case "Plant Id":
            assign(headerName, row.plantId);
            break;
          // case "Material Number":
          //   assign(headerName, row.materialNumber);
          //   break;
          case "IO Extraction Date":
            assign(headerName, row.ioExtractionDate);
            break;
          case "Urgency":
            assign(headerName, row.urgency);
            break;

          // handle API typo safely: ssaIdetifier vs ssaIdentifier
          case "SSA Identifier":
            assign(headerName, (row as any).ssaIdetifier ?? (row as any).ssaIdentifier ?? "");
            break;

          case "MS Case ID":
            assign(headerName, row.msCaseId);
            break;
          case "MS Case Number":
            assign(headerName, row.msCaseNumber);
            break;
          case "Created Timestamp":
            assign(headerName, row.createdTimestamp);
            break;
          case "Last Modified Date":
            assign(headerName, row.lastModifiedDate);
            break;

          case "Ticket Status":
            assign(headerName, getTicketStatus(row));
            break;

          default:
            // Fallback: header → toFieldName(header) matches a key in row
            // This keeps future additions robust if you add new columns
            // with the same name pattern as the API keys.
            {
              const field = toFieldName(headerName);
              (obj as any)[field] = (row as any)[field] ?? "";
            }
            break;
        }
      };

      if (col.children) {
        col.children.forEach((child: any) => {
          mapOne(child.headerName);
        });
      } else {
        mapOne(col.headerName);
      }
    });

    return obj;
  });
  console.log("data",data)
  return data
};